const getMinutesSecondsText = (minutes, seconds) => {
  if (minutes === 0) {
    return `${seconds} ${seconds > 1 ? 'secs' : 'sec'}`
  }

  if (minutes > 0) {
    return `${minutes} ${minutes > 1 ? 'mins' : 'min'}${seconds > 0 ? ` and ${seconds} ${seconds > 1 ? 'secs' : 'sec'}` : ''}`
  }    
}

export default getMinutesSecondsText